/* Cubold FAQs: only one answer open at a time */
(function () {
  if (window.__cgFaqx) return;
  window.__cgFaqx = true;
  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!item.matches || !item.matches('.cg-faqx__item') || !item.open) return;
    var list = item.closest('.cg-faqx__list');
    if (!list) return;
    list.querySelectorAll('.cg-faqx__item[open]').forEach(function (other) {
      if (other !== item) other.open = false;
    });
  }, true);
})();